import Intercom, { boot, shutdown, update } from '@intercom/messenger-js-sdk';

import { isKioskDevice } from 'lib/helpers/kiosk';
import { getSessionReplayAttrs } from 'lib/helpers/intercomSessionReplay';

let patientBooted = false;
let patientLauncherHidden = false;

// The messenger must never appear on the shared in-office kiosk device.
export const isPatientIntercomAllowed = (pathname = window.location.pathname) =>
  !isKioskDevice() && !pathname.startsWith('/kiosk');

const LAUNCHER_HIDDEN_PREFIXES = ['/checkin', '/instant-packet', '/mobile/checkin'];

const isLauncherHiddenRoute = (pathname = window.location.pathname) =>
  LAUNCHER_HIDDEN_PREFIXES.some((prefix) => pathname.startsWith(prefix));

// user is omitted on anonymous surfaces (/book, /invoice/:token, /ia, /instant-packet)
export const bootPatientIntercom = ({ user, hideLauncher } = {}) => {
  if (!isPatientIntercomAllowed()) return false;
  const hideDefaultLauncher = hideLauncher ?? isLauncherHiddenRoute();
  const settings = {
    app_id: process.env.INTERCOM_APP_ID,
    hide_default_launcher: hideDefaultLauncher,
    profileType: 'patient',
    ...(user?.id && {
      // user_id must equal the backend Intercom contact external_id (User.id)
      user_id: user.id,
      email: user.email,
      phone: user.phone,
      name: `${user.f_name ?? ''} ${user.l_name ?? ''}`.trim(),
      created_at: user.created_at
    }),
    ...getSessionReplayAttrs()
  };
  Intercom(settings);
  // update alone won't restart a session after shutdown() (logout -> login in
  // the same SPA session), so boot explicitly
  boot(settings);
  patientBooted = true;
  patientLauncherHidden = hideDefaultLauncher;
  return true;
};

export const isPatientIntercomLauncherHidden = () => patientBooted && patientLauncherHidden;

export const syncPatientIntercomLauncher = (pathname = window.location.pathname) => {
  if (!patientBooted) return;
  const shouldHide = isLauncherHiddenRoute(pathname);
  if (shouldHide === patientLauncherHidden) return;
  update({ hide_default_launcher: shouldHide });
  patientLauncherHidden = shouldHide;
};

export const shutdownPatientIntercom = () => {
  if (!patientBooted) return;
  shutdown();
  patientBooted = false;
  patientLauncherHidden = false;
};
